import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  size: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['default', 'large', 'small'],
    delimiter: '\n  ',
  },
  orientation: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'horizontal', 'vertical'],
    delimiter: '\n  ',
  },
};
const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'Tabs playground',
  coreComponent: {
    html: `<tag-tabs{{...knobs}}>
  <tag-tab caption='Tab 1' name='tab1'>
    <p>Tab1 content ...</p>
  </tag-tab>
  <tag-tab caption='Tab 2' name='tab2' selected>
  <p>Tab2 content ...</p>
  </tag-tab>
  <tag-tab caption='Tab 3' name='tab3'>
    <p>Tab3 content ...</p>
  </tag-tab>
  <tag-tab caption='Tab 4' name='tab4' hidden>
    <p>Tab4 content ...</p>
  </tag-tab>
</tag-tabs>`,
    knobs: PlaygroundStoryKnobs,
  },
  reactWrapper: {
    jsx: `<TagTabs
  tabs={[{
    caption: 'Tab 1',
    name: 'tab1',
    renderContent: () => <p>Tab1 content ...</p>,
  },
  {
    caption: 'Tab 2',
    name: 'tab2',
    renderContent: () => <p>Tab2 content ...</p>,
    selected: true,
  },
  {
    caption: 'Tab 3',
    name: 'tab3',
    renderContent: () => <p>Tab3 content ...</p>,
  },
  {
    caption: 'Tab 4',
    name: 'tab4',
    hidden: true,
    renderContent: () => <p>Tab4 content ...</p>,
  }]}{{...knobs}}
/>`,
    knobs: PlaygroundStoryKnobs,
  },
};

const OnDemandStory: Story = {
  title: 'On demand',
  description: 'How to render a tabs content when the tab is selected',
  coreComponent: {
    html: `<tag-tabs data-name="demo"{{...knobs}}>
  <tag-tab caption='Tab 1' name='tab1'>
  </tag-tab>
  <tag-tab caption='Tab 2' name='tab2'>
  </tag-tab>
  <div class='tab-content' style='padding:20px 10px; background-color:white;'>
    Content for Tab 1
  </div>
</tag-tabs>`,
    js: `var tagTabs = document.querySelector('tag-tabs[data-name="demo"]');
tagTabs.componentOnReady().then(function() {
  tagTabs.addEventListener('tabChange', function(e) {
    var tabContent = tagTabs.querySelector('.tab-content');
    tabContent.textContent =
      'Content for ' + e.detail.name + ' rendered at ' + new Date().toLocaleTimeString();
  });
});`,
  },
  reactWrapper: {
    jsx: `<TagTabs
  tabs={[{
    caption: 'Tab 1',
    name: 'tab1',
    renderContent: () => <p>Content for tab1 rendered at {new Date().toLocaleTimeString()}</p>,
  },
  {
    caption: 'Tab 2',
    name: 'tab2',
    renderContent: () => <p>Content for tab2 rendered at {new Date().toLocaleTimeString()}</p>,
    selected: true,
  }]}
/>`,
  },
};

const TabsWithinTabsStory: Story = {
  title: 'Tabs within tabs',
  description: 'Horizontal tabs within vertical tabs',
  coreComponent: {
    html: `<div style='background-color: white;'>
  <tag-tabs orientation='vertical'>
    <tag-tab name="Tab1" caption='Tab 1'>
      <div style='margin-left:30px;'>
        <tag-tabs orientation='horizontal'>
          <tag-tab name="TabA" caption='Tab A'><div style='margin-top:20px;'>Tab 1 + Tab A</div></tag-tab>
          <tag-tab name="TabB" caption='Tab B' style='margin-top:20px;'><div>Tab 1 + Tab B</div></tag-tab>
          <tag-tab name="TabC" caption='Tab C' style='margin-top:20px;'><div>Tab 1 + Tab C</div></tag-tab>
        </tag-tabs>
      </div>
    </tag-tab>
    <tag-tab name="Tab2" caption='Tab 2'>
      <div style='margin-left:30px;'>
        <tag-tabs orientation='horizontal'>
          <tag-tab name="TabD" caption='Tab D' style='margin-top:20px;'><div>Tab 2 + Tab D</div></tag-tab>
          <tag-tab name="TabE" caption='Tab E' style='margin-top:20px;'><div>Tab 2 + Tab E</div></tag-tab>
          <tag-tab name="TabF" caption='Tab F' style='margin-top:20px;'><div>Tab 2 + Tab F</div></tag-tab>
        </tag-tabs>
      </div>
    </tag-tab>
  </tag-tabs>
</div>`,
  },
  reactWrapper: {
    jsx: `<TagTabs
  orientation="vertical"
  tabs={[
    {
      caption: 'Tab 1',
      name: 'Tab1',
      renderContent: () => (
        <div style={{ marginLeft: '10px' }}>
          <TagTabs
            orientation="horizontal"
            tabs={[
              {
                caption: 'Tab A',
                name: 'TabA',
                renderContent: () => <div style={{ marginTop: '20px' }}>Tab 1 + Tab A</div>,
              },
              {
                caption: 'Tab B',
                name: 'TabB',
                renderContent: () => <div style={{ marginTop: '20px' }}>Tab 1 + Tab B</div>,
              },
              {
                caption: 'Tab C',
                name: 'TabC',
                renderContent: () => <div style={{ marginTop: '20px' }}>Tab 1 + Tab C</div>,
              },
            ]}
          />
        </div>
      ),
    },
    {
      caption: 'Tab 2',
      name: 'Tab2',
      renderContent: () => (
        <div style={{ marginLeft: '10px' }}>
          <TagTabs
            orientation="horizontal"
            tabs={[
              {
                caption: 'Tab D',
                name: 'TabD',
                renderContent: () => <div style={{ marginTop: '20px' }}>Tab 2 + Tab D</div>,
              },
              {
                caption: 'Tab E',
                name: 'TabE',
                renderContent: () => <div style={{ marginTop: '20px' }}>Tab 2 + Tab E</div>,
              },
              {
                caption: 'Tab F',
                name: 'TabF',
                renderContent: () => <div style={{ marginTop: '20px' }}>Tab 2 + Tab F</div>,
              },
            ]}
          />
        </div>
      ),
    },
  ]}
  onTabChange={(e) => {
    console.log('Tab changed to ' + e.detail.name);
  }}
/>`,
  },
};

const OldSchoolTabsStory: Story = {
  title: 'Old school tabs',
  description: 'Old school tabs are back!',
  coreComponent: {
    html: `<tag-tabs data-name="demo" accent="white" header-style='{"margin": "0px -30px"}'>
  <tag-tab name="tab1" caption="Tab 1" tab-style='{"background-color": "red"}'><p>Tab 1 content</p></tag-tab>
  <tag-tab name="tab2" caption="Tab 2"><p>Tab 2 content</p></tag-tab>
  <tag-tab name="tab3" caption="Tab 3"><p>Tab 3 content</p></tag-tab>
</tag-tabs>`,
    js: `var tabs = document.querySelector("tag-tabs[data-name='demo']");
var tab1 = document.querySelector("tag-tab[name='tab1']");
var tab2 = document.querySelector("tag-tab[name='tab2']");
var tab3 = document.querySelector("tag-tab[name='tab3']");

function getTabStyle(tabName) {
  var marginBottom = (selectedTab === tabName) ? "-1px" : "0px";
  var margin = tabName === "tab1" ? "0px 0px " + marginBottom + " 30px" : "0px 0px " + marginBottom + " 0px";
  if (selectedTab === tabName) {
    return '{"background-color": "#FFF", "margin": "' + margin + '", "padding": "5px 30px", "border-top": "1px solid #B1B8BF", "border-left": "1px solid #B1B8BF", "border-right": "1px solid #B1B8BF", "border-radius": "2px 2px 0px 0px"}';
  } else {
    return '{"background-color": "#F4F8F9", "margin": "' + margin + '", "padding": "5px 30px", "border-top": "1px solid #B1B8BF", "border-left": "1px solid #B1B8BF", "border-right": "1px solid #B1B8BF", "border-radius": "2px 2px 0px 0px", "border-bottom": "none"}';
  }
}

function styleTabs() {
  tab1.tabStyle = getTabStyle("tab1");
  tab2.tabStyle = getTabStyle("tab2");
  tab3.tabStyle = getTabStyle("tab3");
}

var selectedTab = "tab1";
styleTabs();
tabs.addEventListener("tabChange", function (e) {
  selectedTab = e.detail.name;
  styleTabs();
});
`,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const headerStyle = {
      margin: '0px -30px'
    };
    const tabStyle = {
      backgroundColor: '#F4F8F9',
      margin: '0px',
      padding: '5px 30px',
      border: '1px solid #B1B8BF',
      borderRadius: '2px 2px 0px 0px'
    };
    const selectedTabStyle = {
      backgroundColor: '#FFF',
      borderWidthBottom: '0px',
      marginBottom: '-1px'
    };
    const firstTabStyle = {
      marginLeft: '30px'
    };
    const [selectedTab, setSelectedTab] = React.useState("tab1");
    const getTabStyle = (tabName) => {
      return selectedTab === tabName
        ? { ...tabStyle, ...selectedTabStyle }
        : tabStyle;
    };
    return (
      <TagTabs
        accent="white"
        headerStyle={headerStyle}
        onTabChange={e => setSelectedTab(e.detail.name)}
        tabs={[
          {
            caption: "Tab 1",
            name: "tab1",
            tabStyle: {
              ...getTabStyle("tab1"),
              ...firstTabStyle
            },
            renderContent: () => <p>Tab 1 content</p>
          },
          {
            caption: "Tab 2",
            name: "tab2",
            tabStyle: getTabStyle("tab2"),
            renderContent: () => <p>Tab 2 content</p>
          },
          {
            caption: "Tab 3",
            name: "tab3",
            tabStyle: getTabStyle("tab3"),
            renderContent: () => <p>Tab 3 content</p>
          }
        ]}
      />
    );
  }`,
  },
};

const ControlledSelectedTabStory: Story = {
  title: 'Controlled selected tab',
  description: 'Tabs where the selected tab is controlled by React state',

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [activeTab, setActiveTab] = React.useState('tab2');
    return (
      <React.Fragment>
        <p>Active tab: {activeTab}</p>
        <TagEditField
          label='Go to tab'
          editor='dropdown'
          options={[
            {label: 'Tab 1', value: 'tab1'},
            {label: 'Tab 2', value: 'tab2'},
            {label: 'Tab 3', value: 'tab3'},
          ]}
          value={activeTab}
          onValueChange={e => setActiveTab(e.detail.value)}
        />
        <TagTabs
          tabs={[
            {caption: 'Tab 1', name: 'tab1', selected: activeTab === 'tab1', renderContent: () => <p>Tab 1 content</p>},
            {caption: 'Tab 2', name: 'tab2', selected: activeTab === 'tab2', renderContent: () => <p>Tab 2 content</p>},
            {caption: 'Tab 3', name: 'tab3', selected: activeTab === 'tab3', renderContent: () => <p>Tab 3 content</p>}
          ]}
          onTabChange={e => setActiveTab(e.detail.name) }
        />
      </React.Fragment>
    )
  }`,
  },
};

export const TagTabsDocs: Component = {
  type: 'component',
  name: 'tabs',
  description:
    'DEPRECATED. Use tag-tab-headers instead. Renders a set of tabs with a container for the active content',
  mobileFriendly: true,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'type',
      description: 'The type of tabs to render',
      type: 'underline',
      default: 'underline',
    },
    {
      name: 'accent',
      default: 'viridiangreen',
      description: 'The selected tab accent colour',
      type: 'string',
    },
    {
      name: 'orientation',
      default: 'horizontal',
      description: 'The orientation of tabs',
      type: 'horizontal | vertical',
    },
    {
      name: 'size',
      default: 'default',
      description: 'The size of tabs',
      type: 'default | small | large',
    },
    {
      name: 'containerStyle',
      description: 'The CSS JSON style for the tabs container',
      type: 'string',
    },
    {
      name: 'headerStyle',
      description: 'JSX style object in JSON to apply to the tab content',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'tabChange',
      description: 'Event raised when the active tab changes',
      parameters: [
        {
          name: 'caption',
          description: 'The tab caption',
          type: 'string',
        },
        {
          name: 'name',
          description: 'The tab name',
          type: 'string',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'select',
      description: 'Selects a tab',
      parameters: [
        {
          name: 'key',
          description: 'The caption/name of the tab to select',
          type: 'string',
        },
      ],
      returnType: 'void',
    },
  ],
  stories: [
    PlaygroundStory,
    OnDemandStory,
    TabsWithinTabsStory,
    OldSchoolTabsStory,
    ControlledSelectedTabStory,
  ],
};
